import { render, staticRenderFns } from "./VirtualServerDetails.vue?vue&type=template&id=7ba63c3a&"
import script from "./VirtualServerDetails.vue?vue&type=script&lang=js&"
export * from "./VirtualServerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports